/**
 * Feature flags for UI/UX surfaces that are built but not yet ready for users.
 *
 * These are thin, module-scope aliases over the centralized flag system in
 * `src/config/features` — the values below now honour `REACT_APP_FEATURE_<KEY>`
 * (see `.env.example`) instead of being hard-coded. The flags only gate the
 * user-facing entry points (buttons, tabs, menu items, modals); the underlying
 * logic, components and modals remain in place.
 *
 * Prefer `isFeatureEnabled(FeatureFlagKey.X)` from `src/config/features` in new
 * code — especially anywhere the value must be re-read after a flag changes.
 * Trading verticals are NOT gated here: use `getEnabledTradingTypes()` and
 * friends from the same module.
 *
 * Typed as `boolean` (not the literal `false`) on purpose, so TypeScript does
 * not treat the gated branches as statically unreachable.
 */
import { FeatureFlagKey, isFeatureEnabled } from "../config/features";

// PWA install / "sync with desktop" entry points (Header, MobileHeader, AccountModal).
export const PWA_UI_ENABLED: boolean = isFeatureEnabled(FeatureFlagKey.PWA_UI);

// Fund transfer entry points (AccountModal, AccountDropdown, Portfolio, Collateral table).
export const TRANSFER_UI_ENABLED: boolean = isFeatureEnabled(
  FeatureFlagKey.TRANSFER_UI
);

// Collateral "convert" entry points (Collateral table — desktop row action + mobile button).
export const CONVERT_UI_ENABLED: boolean = isFeatureEnabled(
  FeatureFlagKey.CONVERT_UI
);

// "User Settings" entry point in the account dropdown menu (AccountModal).
export const USER_SETTINGS_UI_ENABLED: boolean = isFeatureEnabled(
  FeatureFlagKey.USER_SETTINGS_UI
);
